// cardapioSection/index.tsx
//
// A aba "Cardápio" é SOMENTE LEITURA. Ela não tem botão de salvar em lugar
// nenhum e não chama serviço: lê o `decryptedInfoToken` que a Configuração já
// tem em mãos e mostra o que veio da última carga do OPS.
//
// A travessia e a detecção de problemas rodam UMA VEZ aqui (useMemo) e descem
// prontas para as sub-telas. São 504 produtos contra 21 categorias na rede real
// — refazer a junção dentro de cada sub-tela seria repetir o mesmo trabalho a
// cada troca de menu.
//
// O aviso de somente leitura fica neste arquivo, acima do switch: assim ele
// aparece no topo das CINCO sub-telas por construção, e não por disciplina de
// quem escrever a sexta.
import React, { useMemo } from "react";
import * as AlfredoStyles from "../../../../styles/components/configuration/sections/cardapioSection/index";
import {
  lerCardapio,
  detectarProblemas,
  AVISOS_SOMENTE_LEITURA,
  ONDE_FICAM_CATEGORIAS_E_GRUPOS,
} from "./regrasDeSaneamento";
import VisaoGeral from "./VisaoGeral";
import Produtos from "./Produtos";
import Combos from "./Combos";
import PrecoPorCanal from "./PrecoPorCanal";
import Saneamento from "./Saneamento";

interface CardapioSectionProps {
  selectedVerticalOption: string;
  decryptedInfoToken: any;
  // O shell passa o mesmo pacote de props para todas as sections. Nada disso é
  // usado aqui — a aba não edita — mas declarar como opcional evita que a
  // chamada em configuration/index.tsx não compile.
  isEditing?: boolean;
  formData?: any;
  handleInputChange?: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string
  ) => void;
  handleSave?: (objectType: any, payload?: any) => void;
  updateState?: (newState: any) => void;
  handleOpenModal?: (type: string, object?: any) => void;
}

const CardapioSection: React.FC<CardapioSectionProps> = ({
  selectedVerticalOption,
  decryptedInfoToken,
}) => {
  const cardapio = useMemo(
    () => lerCardapio(decryptedInfoToken),
    [decryptedInfoToken]
  );
  const problemas = useMemo(() => detectarProblemas(cardapio), [cardapio]);

  const conteudo = (() => {
    switch (selectedVerticalOption) {
      case "Visão geral":
        return <VisaoGeral cardapio={cardapio} problemas={problemas} />;
      case "Produtos":
        return <Produtos cardapio={cardapio} />;
      case "Combos":
        return <Combos cardapio={cardapio} />;
      case "Preço por canal":
        return <PrecoPorCanal cardapio={cardapio} />;
      case "Saneamento":
        return <Saneamento cardapio={cardapio} problemas={problemas} />;
      default:
        return null;
    }
  })();

  // Mesmo default de storesSection/index.tsx: opção de menu que não tem tela
  // cai aqui, sem o aviso de leitura (não há sub-tela para avisar sobre).
  if (conteudo === null) {
    return (
      <div
        style={{
          padding: "var(--sp-40)",
          textAlign: "center",
          color: "#6c757d",
        }}
      >
        <div style={{ fontSize: "var(--fs-6xl)", marginBottom: "var(--sp-16)" }}>
          🔍
        </div>
        <div style={{ fontSize: "var(--fs-lg)", marginBottom: "var(--sp-8)" }}>
          Sessão não encontrada
        </div>
        <div style={{ fontSize: "var(--fs-md)" }}>{selectedVerticalOption}</div>
      </div>
    );
  }

  return (
    <AlfredoStyles.FieldsContainer>
      <AlfredoStyles.AvisoLeitura>
        <AlfredoStyles.MaterialIcons>lock</AlfredoStyles.MaterialIcons>
        <AlfredoStyles.AvisoLeituraTexto>
          {AVISOS_SOMENTE_LEITURA.map((linha) => (
            <AlfredoStyles.AvisoLeituraLinha key={linha}>
              {linha}
            </AlfredoStyles.AvisoLeituraLinha>
          ))}
          <AlfredoStyles.AvisoLeituraNota>
            {ONDE_FICAM_CATEGORIAS_E_GRUPOS}
          </AlfredoStyles.AvisoLeituraNota>
        </AlfredoStyles.AvisoLeituraTexto>
      </AlfredoStyles.AvisoLeitura>

      {conteudo}
    </AlfredoStyles.FieldsContainer>
  );
};

export default CardapioSection;
